import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["text", "view_map"]
  }
  initialize() {

  }
  connect() {
  }
  // Updates the link to ValheimWorldGenerator
  updateMapLink() {
    const text = this.textTarget;
    const viewMapButton = this.view_mapTarget;

    viewMapButton.href = `https://valheim-map.world/?seed=${text.value}&offset=0%2C0&zoom=0.600&view=0&ver=0.156.2`
  }
  // Generates a valid Valheim map seed
  generate() {
    const text = this.textTarget;

    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;

    for (let i = 0; i < 10; ++i) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    text.value = result;

    this.updateMapLink()
  }
}
